import type { JSX } from 'react'

import { ButtonFonts, ButtonCorners } from "/app/libraries/arcana/src/atoms/Button/index.ts"
import { ButtonGroup, ButtonGroupColumnGap, ButtonGroupJustifyContent, ButtonGroupMargins } from "/app/libraries/arcana/src/blocks/ButtonGroup/index.ts"
import { INDENTS } from "/app/libraries/arcana/src/vars/index.ts"
import { LayoutBlockAuth } from "/app/libraries/arcana/src/blocks/LayoutBlock/Templates/index.ts"
import { PrimaryLoginButton, SecondaryFontButton1Button } from "/app/libraries/arcana/src/atoms/Button/Templates/index.ts"
import { TextBlock, TextBlockAlignItems, TextBlockRowGap } from "/app/libraries/arcana/src/blocks/TextBlock/index.ts"
import { TextBoxCaption2Accent, TextBoxHeadline2 } from "/app/libraries/arcana/src/atoms/TextBox/Templates/index.ts"
import { TextDecoration } from "/app/libraries/arcana/src/atoms/TextBox/index.ts"

import { useUnit } from 'effector-react'
import { useTranslation } from 'react-i18next'
import { AppTitle } from '~/shared/ui/components/AppTitle'
import {
  $pendingSignOut,
  $pendingTryAgain,
  $portalUrl,
  openSubscribersPortal,
  signOut,
  tryAgain,
} from '../model'

export function Title(): JSX.Element {
  return <AppTitle t='expired_subscription' />
}

ExpiredPage.displayName = 'ExpiredPage'
export function ExpiredPage(): JSX.Element {
  const { t } = useTranslation()

  const onSignOut = useUnit(signOut)
  const onTryAgain = useUnit(tryAgain)
  const onOpenSubscribersPortal = useUnit(openSubscribersPortal)

  const portalUrl = useUnit($portalUrl)
  const pendingTryAgain = useUnit($pendingTryAgain)
  const pendingSignOut = useUnit($pendingSignOut)
  const pending = pendingTryAgain || pendingSignOut

  return (
    <LayoutBlockAuth>
      <TextBlock
        alignItems={TextBlockAlignItems.Center}
        rowGap={TextBlockRowGap.INDENT_20}
      >
        <TextBoxHeadline2 title={t('inactive_subscription_label')} />
        <a
          href={portalUrl}
          target='_blank'
          rel='noreferrer'
          onClick={(e) => {
            e.preventDefault()
            onOpenSubscribersPortal()
          }}
        >
          <TextBoxCaption2Accent
            title={t('inactive_subscription_redirect_link')}
            textDecoration={TextDecoration.Underline}
          />
        </a>
      </TextBlock>
      <ButtonGroup
        justifyContent={ButtonGroupJustifyContent.Center}
        width={100}
        wrap={true}
        margins={ButtonGroupMargins.SIZE_100}
        columnGap={ButtonGroupColumnGap.INDENT_30}
      >
        <PrimaryLoginButton
          title={t('try_again')}
          font={ButtonFonts.Button1}
          corners={ButtonCorners.CORNERS_10}
          paddings={[INDENTS.INDENT_30]}
          onClick={onTryAgain}
          disabled={pending}
          withLoader
          hideTitleOnLoading
          isLoading={pendingTryAgain}
        />
        <SecondaryFontButton1Button
          title={t('log_out')}
          corners={ButtonCorners.CORNERS_10}
          paddings={[INDENTS.INDENT_30]}
          onClick={onSignOut}
          disabled={pending}
          withLoader
          hideTitleOnLoading
          isLoading={pendingSignOut}
        />
      </ButtonGroup>
    </LayoutBlockAuth>
  )
}
